import { getTsCustomerPortalClient } from '@montugroup/circuit-shared/api/customer-portal.client';
import { formatEscriptToken } from '@montugroup/circuit-shared/utils/escript';
import { useCallback } from 'react';

const client = getTsCustomerPortalClient();

type MutationResult = ReturnType<typeof client.submitEscriptToken.useMutation>;
type Mutate = MutationResult['mutate'];
type MutateAsync = MutationResult['mutateAsync'];

export type SubmitTokenResponseData = Awaited<ReturnType<MutateAsync>>['body']['data'];
export type SubmitTokenSuccessCallbackProps = SubmitTokenResponseData & { token: string };

type UseSubmitTokenProps = {
  onSuccessCallback: (props: SubmitTokenSuccessCallbackProps) => void;
  onErrorCallback: (token: string) => void;
};

/**
 * The useSubmitToken hook interfaces with the submitToken contract to allow the front end to send a POST request to the endpoint
 *
 * @param root0
 * @param root0.onSuccessCallback
 * @param root0.onErrorCallback
 * @returns mutate
 */
export function useSubmitToken({ onSuccessCallback, onErrorCallback }: UseSubmitTokenProps) {
  const { mutate } = client.submitEscriptToken.useMutation({
    onSuccess: (response, variables) => {
      const data = response.body.data;
      const { token } = variables.body.data;

      onSuccessCallback({
        ...data,
        token,
      });
    },
    onError: (_err, variables) => {
      const { token } = variables.body.data;
      onErrorCallback(token);
    },
  });

  const parsedTokenMutate: Mutate = useCallback(
    (variables) => {
      return mutate({
        ...variables,
        body: {
          ...variables.body,
          data: {
            ...variables.body.data,
            token: formatEscriptToken(variables.body.data.token),
          },
        },
      });
    },
    [mutate],
  );

  return {
    parsedTokenMutate,
  };
}
